import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getFilterList() {
    return this.http.get(`${this.apiUrl}/catalog/graph`);
  }
}
